module.exports = __webpack_public_path__ + "static/media/7-active.f243eb87.png";